import LIST_ACTION_TYPES from "./actiontypes"
import { feedbackSchema } from "../schema"
import { paginatedListReducerFactory } from "core/factories/reducers"

const {
  FETCH_LIST_FAILURE,
  FETCH_LIST_REQUEST,
  FETCH_LIST_SUCCESS,
  INVALIDATE_LIST,
} = LIST_ACTION_TYPES

const listReducer = paginatedListReducerFactory(
  {
    listRequest: FETCH_LIST_REQUEST,
    listSuccess: FETCH_LIST_SUCCESS,
    listFailure: FETCH_LIST_FAILURE,
    invalidateList: INVALIDATE_LIST,
  },
  feedbackSchema
)

export default listReducer
